import { useParams } from "react-router-dom";
import { useCalculationData } from "../../../hooks/useCalculationData";

import { 
  Box, Breadcrumbs, 
  Typography, 
  useTheme 
} from "@mui/material";
import styled from "styled-components";

// import { useGetTitle } from "../../../hooks/useGetTitle";
// import TableComponent from "../../../components/common/SingleTableComponent";
// import RedCheck from "../../../components/icons/RedCheck";
// import FrequencyTable from "../../../components/Table/FrequencyTable";
// import ImportancyTable from "../../../components/Table/ImportancyTable";

import CalculationTable from "../../../components/Table/CalculationTable";
import { BreadcrumbsTable } from "../../../components/common/HelperFunc";
import { FONT_PROPS, COLORS } from "../../../styles/colors";

///////////////////////////////
// 스타일
///////////////////////////////

// 테이블 컨테이너 스타일
const TableContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 40px 5% 0px 5%;
  & > *:nth-child(n+2) {
    margin-top: 40px;
  }
`;

///////////////////////////////
// 위험성 추정 기준표 컴포넌트
///////////////////////////////
const PARENT_TITLE = "정보관리";
const CHILD_TITLE = "위험성 추정 기준표";
export function StandardCriteriaTable() {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  const { tableData } = useCalculationData(group_code, project_code);
  const { frequencyData, importancyData, standardData } = tableData;

  // 데이터가 있을 때 렌더링
  function renderData() {
    return (
      <TableContainer>
        {/* 추정 기준표 */}
        <CalculationTable
          frequencyData={frequencyData}
          importancyData={importancyData}
          standardData={standardData}
        />
      </TableContainer>
    );
  }

  // StandardCriteriaTable 렌더링
  return (
    <Box sx={{ bgcolor: 'var(--mui-palette-background-paper)',height: '100%',display: 'flex',flexDirection: 'column'}}>
      {/* 브레드크럼 + 타이틀 */}
      <BreadcrumbsTable parentTitle={PARENT_TITLE} childTitle={CHILD_TITLE} />
      {/* 테이블 표시 */}
      {renderData()}
    </Box>
  );
}